export default function LeftContent() {
  return (
    <div className="text-white space-y-6">
      <div className="space-y-2">
        <h1 className="text-5xl lg:text-6xl font-bold leading-tight">SIENG</h1>
        <p className="text-xl text-blue-100">스마트 물탱크 관리 시스템</p>
      </div>

      <div className="space-y-4 text-lg text-blue-50 max-w-lg">
        <p>
          실시간 분석 및 지능형 자동화를 통해 물 분배 시스템을 모니터링, 제어 및
          최적화하는 첨단 물탱크 관리 솔루션입니다.
        </p>

        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-drop-line text-cyan-300"></i>
            </div>
            <span>실시간 수질 모니터링</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-chart-line text-cyan-300"></i>
            </div>
            <span>고급 분석 및 리포팅</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-shield-check-line text-cyan-300"></i>
            </div>
            <span>자동 안전 제어</span>
          </div>
        </div>
      </div>
    </div>
  );
}
